unit DonationsForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, BaseList, Data.DB, WEBLib.ExtCtrls, WEBLib.Actions, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Grids, WEBLib.DBCtrls, Vcl.Controls, WEBLib.Lists, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.WebCtrls, smx.webcore.types, XData.Web.Client, Paginator.Plugins;

type
  TDonationsList = class(TBaseListForm)
    CaptionSpan: THTMLSpan;
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetExternalId: TStringField;
    MainDatasetSponsored: TBooleanField;
    MainDatasetTransactionDate: TDateTimeField;
    MainDatasetImportId: TIntegerField;
    MainDatasetClaimId: TIntegerField;
    MainDatasetGiftAid: TFloatField;
    MainDatasetAmount: TFloatField;
    MainDatasetDonorId: TIntegerField;
    MainDatasetClaimStatus: TStringField;
    MainDatasetClaimDate: TDateTimeField;
    MainDatasetTaxYear: TIntegerField;
    MainDatasetClaimRef: TStringField;
    MainDatasetDonorPostCode: TStringField;
    MainDatasetDonorName: TStringField;
    MainDatasetErrorText: TStringField;
    MainDatasetCharityTenant: TStringField;
    MainDatasetSourceType: TStringField;
    DownloadListButton: TButton;
    WebTimer1: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure SearchButtonClick(Sender: TObject);
    procedure DownloadListButtonClick(Sender: TObject);
  private
    FShowStatus: String;
    FAllRows: TJSArray;
    FCurrentPage: Integer;
    FPaginatorPlugin: TPaginatorPlugin;
    procedure SetShowCaption(const Value: String);
    procedure PopulateCurrentPage;
    procedure PaginatorPageClick(APaginatorPlugin: TPaginatorPlugin);
    procedure DonationsPageSizeChange(Sender: TObject);
    function GetPageSize: Integer;
    [async]
    procedure LoadServiceData; async;
    //procedure SetGrid;
    { Private declarations }
  protected
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;
    procedure PrepareForm; override;
    procedure LoadData; override;

    //function GetEditFormClass: TWebFormClass;
    function InitSortCol: Integer;override;
    function InitSortDirection: TSortDirection;override;
    function CreateGridInFormCreate: boolean;override;
    procedure SearchData(const Value: string);override;
    [async]
    procedure GenerateUnclaimedDonationsCSVFile; async;

  public
    { Public declarations }
    property ShowStatus: String read FShowStatus write FShowStatus;
    property ShowCaption: String write SetShowCaption;

  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses
  MainDataModule,
  Reports.Donation.Utils;


procedure TDonationsList.WebFormCreate(Sender: TObject);
begin
  inherited;
  FAllRows := TJSArray.new;
  FCurrentPage := 1;
  FPaginatorPlugin := TPaginatorPlugin.Create(lcPaginator, @PaginatorPageClick);
  cbPageSize.OnChange := @DonationsPageSizeChange;
  AddButton.Visible := False;
  AddButton.Enabled := False;
end;

{ TUnclaimedDonations }

procedure TDonationsList.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
begin
  inherited;

end;

procedure TDonationsList.LoadData;
begin
  LoadServiceData;
end;

procedure TDonationsList.PrepareForm;
begin
  FIdField := 'Id';
end;

procedure TDonationsList.SearchButtonClick(Sender: TObject);
begin
  SearchData(edSearch.Text);
end;

procedure TDonationsList.SetShowCaption(const Value: String);
begin
 CaptionSpan.HTML.Text := Value;
end;

procedure TDonationsList.WebFormShow(Sender: TObject);
begin
  inherited;
  LoadData;
end;

procedure TDonationsList.SearchData(const Value: string);
begin
  FCurrentPage := 1;
  PopulateCurrentPage;
end;

function TDonationsList.GetPageSize: Integer;
begin
  Result := StrToIntDef(cbPageSize.Text, 10);
  if Result < 1 then
    Result := 10;
end;

procedure TDonationsList.DonationsPageSizeChange(Sender: TObject);
begin
  FCurrentPage := 1;
  PopulateCurrentPage;
end;

procedure TDonationsList.PaginatorPageClick(APaginatorPlugin: TPaginatorPlugin);
begin
  FCurrentPage := APaginatorPlugin.ActivePage;
  PopulateCurrentPage;
end;

procedure TDonationsList.PopulateCurrentPage;
var
  LRows: TJSArray;
  LItem: TJSObject;
  LRow: TJSObject;
  LFilterText: string;
  LSkip: Integer;
  LIndex: Integer;
  LFilteredCount: Integer;
  LPageSize: Integer;
  LPageCount: Integer;
  LFirstRecord: Integer;
  LLastRecord: Integer;
begin
  if FAllRows = nil then
    FAllRows := TJSArray.new;

  LRows := TJSArray.new;
  LFilterText := LowerCase(edSearch.Text.Trim);
  LPageSize := GetPageSize;
  LSkip := (FCurrentPage - 1) * LPageSize;
  LFilteredCount := 0;

  for LIndex := 0 to FAllRows.Length - 1 do
  begin
    LItem := TJSObject(FAllRows[LIndex]);
    if (LFilterText = '') or
      (Pos(LFilterText, LowerCase(string(LItem['DonorName']))) > 0) or
      (Pos(LFilterText, LowerCase(string(LItem['DonorPostCode']))) > 0) then
    begin
      Inc(LFilteredCount);
      if LSkip > 0 then
        Dec(LSkip)
      else if LRows.Length < LPageSize then
      begin
        LRow := TJSObject.new;
        LRow['Id'] := LItem['Id'];
        LRow['DateAdded'] := LItem['DateAdded'];
        LRow['AddedBy'] := LItem['AddedBy'];
        LRow['LastUpdatedBy'] := LItem['LastUpdatedBy'];
        LRow['LastUpdated'] := LItem['LastUpdated'];
        LRow['ExternalId'] := LItem['ExternalId'];
        LRow['Sponsored'] := LItem['Sponsored'];
        LRow['TransactionDate'] := LItem['TransactionDate'];
        LRow['ImportId'] := LItem['ImportId'];
        LRow['ClaimId'] := LItem['ClaimId'];
        LRow['GiftAid'] := LItem['GiftAid'];
        LRow['Amount'] := LItem['Amount'];
        LRow['DonorId'] := LItem['DonorId'];
        LRow['ClaimStatus'] := LItem['ClaimStatus'];
        LRow['ClaimDate'] := LItem['ClaimDate'];
        LRow['TaxYear'] := LItem['TaxYear'];
        LRow['ClaimRef'] := LItem['ClaimRef'];
        LRow['DonorPostCode'] := LItem['DonorPostCode'];
        LRow['DonorName'] := LItem['DonorName'];
        LRow['ErrorText'] := LItem['ErrorText'];
        LRow['CharityTenant'] := LItem['CharityTenant'];
        LRow['SourceType'] := LItem['SourceType'];
        LRows.Push(LRow);
      end;
    end;
  end;

  if LFilteredCount = 0 then
  begin
    FCurrentPage := 1;
    lcPaginator.Items.Clear;
    lbPaginationInfo.Caption := 'No records';
  end
  else
  begin
    LPageCount := (LFilteredCount + LPageSize - 1) div LPageSize;
    if FCurrentPage > LPageCount then
    begin
      FCurrentPage := LPageCount;
      PopulateCurrentPage;
      Exit;
    end;

    FPaginatorPlugin.Init(FCurrentPage, LPageCount);
    LFirstRecord := ((FCurrentPage - 1) * LPageSize) + 1;
    LLastRecord := LFirstRecord + LRows.Length - 1;
    if LLastRecord > LFilteredCount then
      LLastRecord := LFilteredCount;
    lbPaginationInfo.Caption := Format('%d to %d of %d', [LFirstRecord, LLastRecord, LFilteredCount]);
  end;

  MainDataset.Active := False;
  MainDataset.SetJsonData(LRows);
  MainDataset.Active := True;
  DataTable.Invalidate;
end;

procedure TDonationsList.LoadServiceData;
var
  LResponse: TXDataClientResponse;
begin
  UnLockControls(False);
  try
    LResponse := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetUnclaimedDonationsList', []));

    if (LResponse.ResultAsObject <> nil) and (LResponse.ResultAsObject['value'] <> nil) then
      FAllRows := TJSArray(LResponse.ResultAsObject['value'])
    else
      FAllRows := TJSArray.new;

    FCurrentPage := 1;
    PopulateCurrentPage;
  finally
    UnLockControls(True);
    AddButton.Visible := False;
    AddButton.Enabled := False;
  end;
end;

function TDonationsList.InitSortCol: Integer;
begin
  Result := 1;
end;

function TDonationsList.InitSortDirection: TSortDirection;
begin
  Result := TSortDirection.sdDesc;
end;

function TDonationsList.CreateGridInFormCreate: boolean;
begin
  result := false;
end;

procedure TDonationsList.DownloadListButtonClick(Sender: TObject);
begin
  GenerateUnclaimedDonationsCSVFile;
end;


procedure TDonationsList.GenerateUnclaimedDonationsCSVFile;
//var
begin
  Await(TDonationReportUtils.DonationReport('DN.CLAIM_STATUS', 'Unclaimed', 0, 0, '', '', TReportOutput.roCSV));
end;

(*
procedure TDonationsList.GenerateUnclaimedDonationsCSVFile;
var
  lRetval: TXDataClientResponse;
  lData: string;
  lFileName: string;
  lTimeStamp: string;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.CreateUnclaimedDonationsCSVFile', []));
  lData  := JS.ToString(lRetval.ResultAsObject['value']);
  lTimeStamp := FormatDateTime('YYYYMMDDhhnnss', Now);
  lFileName := Format('GiftAider-UnclaimedDonations_%s.csv', [lTimeStamp]);

  Application.DownloadTextFile(lData, lFileName);
end;
*)

(*
procedure TDonationsList.SetGrid;
begin
//  DataTable.Columns[0].DataField := 'Id';
//  DataTable.Columns[0].Title := 'Donor Id';

  DataTable.Columns[1].DataField := '';
  DataTable.Columns[1].Title := 'Donor Name';

  DataTable.Columns.Delete(2);
end;
*)



procedure TDonationsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  CaptionSpan := THTMLSpan.Create('CaptionSpan');
  DownloadListButton := TButton.Create('UnclaimedDonations');
  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetExternalId := TStringField.Create(Self);
  MainDatasetSponsored := TBooleanField.Create(Self);
  MainDatasetTransactionDate := TDateTimeField.Create(Self);
  MainDatasetImportId := TIntegerField.Create(Self);
  MainDatasetClaimId := TIntegerField.Create(Self);
  MainDatasetGiftAid := TFloatField.Create(Self);
  MainDatasetAmount := TFloatField.Create(Self);
  MainDatasetDonorId := TIntegerField.Create(Self);
  MainDatasetClaimStatus := TStringField.Create(Self);
  MainDatasetClaimDate := TDateTimeField.Create(Self);
  MainDatasetTaxYear := TIntegerField.Create(Self);
  MainDatasetClaimRef := TStringField.Create(Self);
  MainDatasetDonorPostCode := TStringField.Create(Self);
  MainDatasetDonorName := TStringField.Create(Self);
  MainDatasetErrorText := TStringField.Create(Self);
  MainDatasetCharityTenant := TStringField.Create(Self);
  MainDatasetSourceType := TStringField.Create(Self);
  WebTimer1 := TTimer.Create(Self);

  DataTable.BeforeLoadDFMValues;
  CaptionSpan.BeforeLoadDFMValues;
  DownloadListButton.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetExternalId.BeforeLoadDFMValues;
  MainDatasetSponsored.BeforeLoadDFMValues;
  MainDatasetTransactionDate.BeforeLoadDFMValues;
  MainDatasetImportId.BeforeLoadDFMValues;
  MainDatasetClaimId.BeforeLoadDFMValues;
  MainDatasetGiftAid.BeforeLoadDFMValues;
  MainDatasetAmount.BeforeLoadDFMValues;
  MainDatasetDonorId.BeforeLoadDFMValues;
  MainDatasetClaimStatus.BeforeLoadDFMValues;
  MainDatasetClaimDate.BeforeLoadDFMValues;
  MainDatasetTaxYear.BeforeLoadDFMValues;
  MainDatasetClaimRef.BeforeLoadDFMValues;
  MainDatasetDonorPostCode.BeforeLoadDFMValues;
  MainDatasetDonorName.BeforeLoadDFMValues;
  MainDatasetErrorText.BeforeLoadDFMValues;
  MainDatasetCharityTenant.BeforeLoadDFMValues;
  MainDatasetSourceType.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Top := 110;
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'TransactionDate';
      Title := 'Transaction Date';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'DonorName';
      Title := 'Donor';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'DonorPostCode';
      Title := 'Post Code';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Amount';
      Title := 'Amount';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ClaimStatus';
      Title := 'ClaimStatus';
    end;
    CaptionSpan.SetParentComponent(Self);
    CaptionSpan.Name := 'CaptionSpan';
    CaptionSpan.Left := 632;
    CaptionSpan.Top := 48;
    CaptionSpan.Width := 100;
    CaptionSpan.Height := 40;
    CaptionSpan.HeightStyle := ssAuto;
    CaptionSpan.WidthStyle := ssAuto;
    CaptionSpan.ChildOrder := 10;
    CaptionSpan.ElementPosition := epIgnore;
    CaptionSpan.ElementFont := efCSS;
    CaptionSpan.Role := '';
    DownloadListButton.SetParentComponent(Self);
    DownloadListButton.Name := 'DownloadListButton';
    DownloadListButton.Left := 207;
    DownloadListButton.Top := 439;
    DownloadListButton.Width := 297;
    DownloadListButton.Height := 25;
    DownloadListButton.Caption := 'Download Unnclaimed Donations';
    DownloadListButton.ChildOrder := 9;
    DownloadListButton.ElementClassName := 'btn btn-secondary';
    DownloadListButton.ElementPosition := epIgnore;
    DownloadListButton.HeightStyle := ssAuto;
    DownloadListButton.HeightPercent := 100.000000000000000000;
    DownloadListButton.WidthStyle := ssAuto;
    DownloadListButton.WidthPercent := 100.000000000000000000;
    SetEvent(DownloadListButton, Self, 'OnClick', 'DownloadListButtonClick');
    MainDataset.EntitySetName := 'Donation';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetExternalId.SetParentComponent(MainDataset);
    MainDatasetExternalId.Name := 'MainDatasetExternalId';
    MainDatasetExternalId.FieldName := 'ExternalId';
    MainDatasetExternalId.Size := 255;
    MainDatasetSponsored.SetParentComponent(MainDataset);
    MainDatasetSponsored.Name := 'MainDatasetSponsored';
    MainDatasetSponsored.FieldName := 'Sponsored';
    MainDatasetTransactionDate.SetParentComponent(MainDataset);
    MainDatasetTransactionDate.Name := 'MainDatasetTransactionDate';
    MainDatasetTransactionDate.FieldName := 'TransactionDate';
    MainDatasetTransactionDate.DisplayFormat := 'DD/MM/YYYY';
    MainDatasetImportId.SetParentComponent(MainDataset);
    MainDatasetImportId.Name := 'MainDatasetImportId';
    MainDatasetImportId.FieldName := 'ImportId';
    MainDatasetClaimId.SetParentComponent(MainDataset);
    MainDatasetClaimId.Name := 'MainDatasetClaimId';
    MainDatasetClaimId.FieldName := 'ClaimId';
    MainDatasetGiftAid.SetParentComponent(MainDataset);
    MainDatasetGiftAid.Name := 'MainDatasetGiftAid';
    MainDatasetGiftAid.FieldName := 'GiftAid';
    MainDatasetAmount.SetParentComponent(MainDataset);
    MainDatasetAmount.Name := 'MainDatasetAmount';
    MainDatasetAmount.FieldName := 'Amount';
    MainDatasetDonorId.SetParentComponent(MainDataset);
    MainDatasetDonorId.Name := 'MainDatasetDonorId';
    MainDatasetDonorId.FieldName := 'DonorId';
    MainDatasetClaimStatus.SetParentComponent(MainDataset);
    MainDatasetClaimStatus.Name := 'MainDatasetClaimStatus';
    MainDatasetClaimStatus.FieldName := 'ClaimStatus';
    MainDatasetClaimStatus.Size := 9;
    MainDatasetClaimDate.SetParentComponent(MainDataset);
    MainDatasetClaimDate.Name := 'MainDatasetClaimDate';
    MainDatasetClaimDate.FieldName := 'ClaimDate';
    MainDatasetTaxYear.SetParentComponent(MainDataset);
    MainDatasetTaxYear.Name := 'MainDatasetTaxYear';
    MainDatasetTaxYear.FieldName := 'TaxYear';
    MainDatasetClaimRef.SetParentComponent(MainDataset);
    MainDatasetClaimRef.Name := 'MainDatasetClaimRef';
    MainDatasetClaimRef.FieldName := 'ClaimRef';
    MainDatasetClaimRef.Size := 32;
    MainDatasetDonorPostCode.SetParentComponent(MainDataset);
    MainDatasetDonorPostCode.Name := 'MainDatasetDonorPostCode';
    MainDatasetDonorPostCode.FieldName := 'DonorPostCode';
    MainDatasetDonorPostCode.Size := 15;
    MainDatasetDonorName.SetParentComponent(MainDataset);
    MainDatasetDonorName.Name := 'MainDatasetDonorName';
    MainDatasetDonorName.FieldName := 'DonorName';
    MainDatasetDonorName.Size := 50;
    MainDatasetErrorText.SetParentComponent(MainDataset);
    MainDatasetErrorText.Name := 'MainDatasetErrorText';
    MainDatasetErrorText.FieldName := 'ErrorText';
    MainDatasetErrorText.Size := 1000;
    MainDatasetCharityTenant.SetParentComponent(MainDataset);
    MainDatasetCharityTenant.Name := 'MainDatasetCharityTenant';
    MainDatasetCharityTenant.FieldName := 'CharityTenant';
    MainDatasetSourceType.SetParentComponent(MainDataset);
    MainDatasetSourceType.Name := 'MainDatasetSourceType';
    MainDatasetSourceType.FieldName := 'SourceType';
    MainDatasetSourceType.Size := 9;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Left := 48;
    WebTimer1.Top := 432;
  finally
    DataTable.AfterLoadDFMValues;
    CaptionSpan.AfterLoadDFMValues;
    DownloadListButton.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetExternalId.AfterLoadDFMValues;
    MainDatasetSponsored.AfterLoadDFMValues;
    MainDatasetTransactionDate.AfterLoadDFMValues;
    MainDatasetImportId.AfterLoadDFMValues;
    MainDatasetClaimId.AfterLoadDFMValues;
    MainDatasetGiftAid.AfterLoadDFMValues;
    MainDatasetAmount.AfterLoadDFMValues;
    MainDatasetDonorId.AfterLoadDFMValues;
    MainDatasetClaimStatus.AfterLoadDFMValues;
    MainDatasetClaimDate.AfterLoadDFMValues;
    MainDatasetTaxYear.AfterLoadDFMValues;
    MainDatasetClaimRef.AfterLoadDFMValues;
    MainDatasetDonorPostCode.AfterLoadDFMValues;
    MainDatasetDonorName.AfterLoadDFMValues;
    MainDatasetErrorText.AfterLoadDFMValues;
    MainDatasetCharityTenant.AfterLoadDFMValues;
    MainDatasetSourceType.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
  end;
end;

end.
